var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('list-item-base',{staticClass:"list-item line-height-thin"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }